import React from "react";
import Button from "designSystem/components/button/Button";
import Placeholder from "designSystem/components/placeholder/Placeholder";
import FashionInspirationIcon from "../fashionInspirationIcon/FashionInspirationIcon";
import { FlexRowCenter } from "designSystem/index";

interface NewExplorationProps {
    handleNewExplorationClick: VoidFunction;
}

const NewExploration = ({ handleNewExplorationClick }: NewExplorationProps) => (
	<FlexRowCenter
		flexGrow={1}
		justifyContent="center"
		px={3}
	>
		<Placeholder
			subtitleMargin={6}
			subtitleProps={{ res: "NewExplorationText" }}
			titleProps={{ res: "NewExplorationTitle" }}
		>
			{{
				actions:
					<Button
						design="primary"
						onClick={handleNewExplorationClick}
						res="NewExplorationButton"
					/>
				,
	
				image: <FashionInspirationIcon mono sx={{ fontSize: 64, fill: "currentColor" }} />,
			}}
		</Placeholder>
	</FlexRowCenter>
);

export default NewExploration;
